import { AddPetCareContent } from './AddPetCareContent';

export const AddPetCareModal = (): JSX.Element => (<AddPetCareContent />);
